import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { assetTypeState, assetsTypesState } from '../../storage/assets';
import { AssetType } from '../../types/asset';
import { ClientSelect } from '../shared/selects/ClientSelect';
import { SubClientSelect } from '../shared/selects/SubClientSelect';
import EnhancedLabeledSelect from '../ui/EnhancedLabeledSelect';

type Props = {
  selectedClientId?: string;
  selectedSubClientId?: string;
  monitoring?: boolean;
  setSelectedClientId: (clientId?: string) => void;
  setSelectedSubClientId: (subClientId?: string) => void;
  setMonitoring: (monitoring?: boolean) => void;
};

export function AssetFilters({
  selectedClientId,
  selectedSubClientId,
  monitoring,
  setSelectedSubClientId,
  setSelectedClientId,
  setMonitoring,
}: Readonly<Props>) {
  const assetTypes = useRecoilValue(assetsTypesState);
  const [selectedAssetType, setSelectedAssetType] = useRecoilState(assetTypeState);

  const assetTypeOptions = useMemo(() => {
    if (!assetTypes) return;
    return [
      {
        id: undefined,
        label: 'Todos',
      },
      ...assetTypes.map((assetType) => ({ id: assetType.key, label: assetType.label })),
    ];
  }, [assetTypes]);

  const onAssetTypeChange = (params: OnChangeParams) => {
    params.option?.id ? setSelectedAssetType(params.option.id as AssetType) : setSelectedAssetType(undefined);
  };

  const onMonitoringChange = (params: OnChangeParams) => {
    params.option?.id ? setMonitoring(params.option.id === 'true') : setMonitoring(undefined);
  };

  const handleClientChange = (clientId?: string) => {
    if (clientId !== selectedClientId) {
      setSelectedClientId(clientId);
      setSelectedSubClientId(undefined);
    }
  };

  return (
    <>
      <EnhancedLabeledSelect
        label="Tipo de activo:"
        options={assetTypeOptions}
        value={[{ id: selectedAssetType }]}
        onChange={onAssetTypeChange}
        inline
        inset
        fullWidth
      />
      <ClientSelect
        selectedClientId={selectedClientId}
        onChangeClientId={handleClientChange}
        inline
      />
      <SubClientSelect
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
        onChangeSubClientId={setSelectedSubClientId}
        disabled={!selectedClientId}
        inline
      />
      <EnhancedLabeledSelect
        label="Monitoreo:"
        options={[
          { id: undefined, label: 'Todos' },
          { id: 'true', label: 'Activo' },
          { id: 'false', label: 'Inactivo' },
        ]}
        value={[{ id: monitoring === undefined ? undefined : `${monitoring}` }]}
        onChange={onMonitoringChange}
        inline
        inset
        fullWidth
      />
    </>
  );
}
